import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=fecc4792&scoped=true&"
import script from "./BannerList.vue?vue&type=script&lang=js&"
export * from "./BannerList.vue?vue&type=script&lang=js&"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=fecc4792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc4792",
  null
  
)

export default component.exports